import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
    selector: 'app-searchable-select',
    templateUrl: './searchable-select.component.html',
    styleUrls: ['./searchable-select.component.scss'],
})
export class SearchableSelectComponent implements OnInit {
    searchFilter = ''
    selectedItem: { id: string; name: string } | null = null

    @Input() items: { id: string; name: string }[] = []
    @Input() placeholder: string = ''

    filteredItems: { id: string; name: string }[] = []

    @Output() onSelectedNewItem = new EventEmitter<{ id: string; name: string } | null>()

    constructor() {}

    ngOnInit(): void {}

    clearSelection() {
        this.searchFilter = ''
        this.selectedItem = null
        this.filteredItems = []
        this.onSelectedNewItem.emit(null)
    }

    onSelectNewItem(item: { id: string; name: string }) {
        this.clearSelection()
        this.selectedItem = item
        this.searchFilter = ''

        this.onSelectedNewItem.emit(item)
    }

    // @ts-ignore
    onFilterChange() {
        if (this.searchFilter === '') {
            return []
        }
        this.filteredItems = this.items.filter(item =>
            item.name.toLowerCase().includes(this.searchFilter.toLowerCase()),
        )
    }
}
